<template>
	<div>
		<annual-sale-2020-banner />
		<timed-content
			v-if="heroPromoHasEndDate && showHeroPromo"
			:from="heroPromoTime.start"
			:to="heroPromoTime.end"
		>
			<hero-promo />
		</timed-content>
		<hero-promo v-else-if="showHeroPromo" />
		<hero-default-v2 v-if="showHeroDefault" />
		<prebuild-pcs-banner />
	</div>
</template>

<script>
import { mapState } from "vuex";
import PrebuildPcsBanner from "./prebuild-pcs-banner";
import HeroDefaultV2 from "./hero-default-v2";
import HeroPromo from "./hero-promo";
import TimedContent from "vue-timed-content";
import AnnualSale2020Banner from "./annual-sale-2020-banner";

export default {
	name: "HeroSection",
	components: {
		PrebuildPcsBanner,
		HeroDefaultV2,
		HeroPromo,
		TimedContent,
		AnnualSale2020Banner
	},
	computed: {
		...mapState({
			topSection: state => state.Home.topSection,
			heroPromo: state => state.Home.heroPromo
		}),
		showHeroPromo() {
			return Boolean(Object.keys(this.heroPromo).length);
		},
		showHeroDefault() {
			return Boolean(Object.keys(this.topSection).length);
		},
		heroPromoTime() {
			const { starts_at: start = "", ends_at: end = "" } = this.heroPromo;

			return {
				start, end
			};
		},
		heroPromoHasEndDate() {
			const { has_end_date: hasEndDate = "0" } = this.heroPromo;

			return Boolean(Number(hasEndDate));
		}
	}
};
</script>
